import { render, staticRenderFns } from "./LetterRow.vue?vue&type=template&id=2bc6565f&scoped=true"
import script from "./LetterRow.vue?vue&type=script&lang=js"
export * from "./LetterRow.vue?vue&type=script&lang=js"
import style0 from "./LetterRow.vue?vue&type=style&index=0&id=2bc6565f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6565f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc6565f')) {
      api.createRecord('2bc6565f', component.options)
    } else {
      api.reload('2bc6565f', component.options)
    }
    module.hot.accept("./LetterRow.vue?vue&type=template&id=2bc6565f&scoped=true", function () {
      api.rerender('2bc6565f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/LetterRow.vue"
export default component.exports